import { render, staticRenderFns } from "./edit-banner.vue?vue&type=template&id=ec52b3e0&"
import script from "./edit-banner.vue?vue&type=script&lang=js&"
export * from "./edit-banner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports